import { Component, OnInit } from '@angular/core';
import { faFile, faFolderOpen, faUserCircle, } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faFileContract, faFileSignature, faPlus, faUser } from '@fortawesome/free-solid-svg-icons';
import { GlobalService } from '../../services/global.service';
import { ContractService } from 'src/app/services/contract.service';
import { EliminaComponent } from 'src/app/popup/elimina/elimina.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssocComponent } from 'src/app/popup/assoc/assoc.component';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit {
  //string
  _listFilter = '';

  //any
  activeUser: any;
  toAssoc: any = {}
  //temp
  tempUser: any;
  type: any;

  //array
  selectedContract: any = { contract: {}, assoc: {}, customer: {} };
  filteredContract: Array<any> = [];
  customers: Array<any> = [];
  types: Array<any>;

  test: Array<any>;

  //boolean
  choose: boolean = false;
  newCont = false;
  del = false;
  nome: boolean;
  dataI: boolean;
  dataF: boolean;
  associa: boolean;

  // Icone
  faPlus = faPlus;
  faFile = faFile;
  faFolderOpen = faFolderOpen;
  faUserCircle = faUserCircle;
  faSearch = faSearch;
  faFileContract = faFileContract;
  faFileSignature = faFileSignature;
  faUser = faUser;


  token: any;
  contracts: any;
  constructor(
    private modalService: NgbModal,
    private globals: GlobalService,
    private contractServices: ContractService,
    private customerService: CustomerService
  ) {
    this.filteredContract = this.contracts;
  }

  ngOnInit() {
    this.activeUser = this.globals.storagedUser;
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getContracts();
    this.getCustomers();
  }

  get listFilter(): string {
    return this._listFilter;
  }

  set listFilter(value: string) {
    this._listFilter = value;
    this.filteredContract = this.listFilter ? this.doFilter(this.listFilter) : this.contracts;

  }
  doFilter(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.contracts.filter((contract) =>
      contract.contract.descriptions.toLocaleLowerCase().indexOf(filterBy) !== -1);
  }

  reload() {
    this.svuotaSpan();
    this.globals.checkPage(6);
    this.selectedContract = { contract: {}, assoc: {}, customer: {} };
    this.del = false;
    this.newCont = false
    this.tempUser = null;
    this.choose = false;
    this.getContracts();
    this.ngOnInit();
  }

  getContracts() {
    this.contractServices.getContracts(this.token).subscribe(
      res => {
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.contracts = res.contracts;
          this.types = res.types;
          this.contracts.forEach(cont => {
            cont.contract.descriptions = `${cont.contract.contract_number} ${cont.contract.contract_name} ${cont.contract.contract_name} ${cont.contract.contract_number}`;

          })
          this.listFilter = '';
        }
      },
      err => {
        console.error("Error on get contract: ", err);
      }
    )
  }

  showForm(contract) {
    this.svuotaSpan();
    this.newCont = false;
    this.del = true;
    this.choose = true;
    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change");
    }
    var element = document.getElementById(`contract${contract.contract.contract_id}`);
    element.classList.add("color-change");
    this.tempUser = `contract${contract.contract.contract_id}`;
    this.selectedContract = contract;
    console.log("Contract before: ", contract);
    
    this.selectedContract.assoc.start_date = this.globals.cleanDate(this.selectedContract.assoc.start_date); 
    this.selectedContract.assoc.end_date = this.globals.cleanDate(this.selectedContract.assoc.end_date);

    console.log("Contract after: ", contract);
    
  }

  newContract() {
    this.svuotaSpan();
    this.del = false;
    this.choose = true;
    this.newCont = true;
    this.selectedContract = { contract: {}, assoc: {}, customer: {} };
    if (this.tempUser) {
      var elementTwo = document.getElementById(this.tempUser);
      elementTwo.classList.remove("color-change")
    }
  }

  addContract(contract) {
    if (contract.contract.contract_name) {
      this.nome = true;
      document.getElementById("name_contract").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("name_contract").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (contract.assoc.start_date) {
      this.dataI = true;
      document.getElementById("DI").innerHTML = "";
    } else {
      this.dataI = false;
      document.getElementById("DI").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (contract.assoc.end_date) {
      this.dataF = true;
      document.getElementById("DF").innerHTML = "";
    } else {
      this.dataF = false;
      document.getElementById("DF").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (contract.assoc.customer_id) {
      this.associa = true;
      document.getElementById("associaCliente").innerHTML = "";
    } else {
      this.associa = false;
      document.getElementById("associaCliente").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (contract.assoc.start_date) {
      if (contract.assoc.start_date > contract.assoc.end_date) {
        this.dataI = false;
        document.getElementById("DI").innerHTML = "↓ La data inizio è più grande della data fine";
      } else {
        document.getElementById("DI").innerHTML = "";
        this.dataI = true;
      }
    }

    if (this.nome && this.dataF && this.dataI && this.associa) {
      let obj: any = {
        contract: {
          contract_name: contract.contract.contract_name,
          description: contract.contract.description
        },
        assoc: {
          start_date: contract.assoc.start_date,
          end_date: contract.assoc.end_date,
          customer_id: contract.assoc.customer_id
        }
      }
      this.contractServices.newContract(this.token, obj).subscribe(
        res => {
          this.reload();
          this.selectedContract = { contract: {}, assoc: {}, customer: {} };
        },
        err => {
          console.error(err);

        }
      )
    }
  }

  svuotaSpan() {
    if (document.getElementById("name_contract")) {
      document.getElementById("name_contract").innerHTML = "";
    }
    if (document.getElementById("DI")) {
      document.getElementById("DI").innerHTML = "";
    }
    if (document.getElementById("DF")) {
      document.getElementById("DF").innerHTML = "";
    }
  }

  deleteContract(id) {

    const modalRef = this.modalService.open(EliminaComponent, { backdrop: 'static', centered: true })
    modalRef.componentInstance.token = this.token;
    modalRef.componentInstance.contract = id.contract;

    modalRef.result.then(result => {

      if (result != 'cancel') {
        this.tempUser = null;
        this.reload();
        let element = document.getElementById(`contract${result}`);
        element.classList.remove("color-change")

      }
    }, reason => {
    });

    // this.contractServices.deleteContract(this.token, id).subscribe(
    //   res => {
    //     console.log(res);
    //     this.reload();
    //   },
    //   err => {
    //     console.error(err);
    //   }
    // )

  }

  updateContract(contra) {
    console.log("Contratto: ", contra);
    
    if (contra.contract.contract_name) {
      this.nome = true;
      document.getElementById("name_contract").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("name_contract").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (contra.assoc.start_date) {
      this.dataI = true;
      document.getElementById("DI").innerHTML = "";
    } else {
      this.dataI = false;
      document.getElementById("DI").innerHTML = "↓ Il campo è obbligatorio";
    }
    if (contra.assoc.end_date) {
      this.dataF = true;
      document.getElementById("DF").innerHTML = "";
    } else {
      this.dataF = false;
      document.getElementById("DF").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (contra.assoc.start_date > contra.assoc.end_date) {
      this.dataI = false;
      document.getElementById("DI").innerHTML = "↓ La data inizio è più grande della data fine";
    } else {
      document.getElementById("DI").innerHTML = "";
      this.dataI = true;
    }

    if (this.nome && this.dataF && this.dataI) {

      let obj: any = {
        contract_number: contra.contract.contract_number,
        contract_name: contra.contract.contract_name,
        description: contra.contract.description
      }
      this.contractServices.updateContract(this.token, { contract: obj }, contra.contract.contract_id).subscribe(
        res => {
          this.reload();
        },
        err => {
          console.error("Errore in updateContract: ", err)
        }
      )
    }
  }

  assoc(id) {
    const modalRef = this.modalService.open(AssocComponent, { backdrop: 'static', centered: true })
    // modalRef.componentInstance.token = this.token;
    modalRef.componentInstance.id = id;

    modalRef.result.then(result => {

      if (result != 'cancel') {
        this.tempUser = null;
        this.reload();

        let element = document.getElementById(`contract${result}`);
        element.classList.remove("color-change")

      }
    }, reason => {
    });
  }

  getCustomers() {
    this.customerService.getCustomer(this.token).subscribe(
      res => {
        this.customers = res;
      },
      err => {
        console.error("Errore nell'ottenere i customers", err);
      }
    )
  }

}
